import script from "./WordPressList.vue?vue&type=script&setup=true&lang=js"
export * from "./WordPressList.vue?vue&type=script&setup=true&lang=js"

import "./WordPressList.vue?vue&type=style&index=0&id=2d78492e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d78492e"]])

export default __exports__